import { render, staticRenderFns } from "./PermissionRole.vue?vue&type=template&id=0abaf90c&scoped=true"
import script from "./PermissionRole.vue?vue&type=script&lang=js"
export * from "./PermissionRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abaf90c",
  null
  
)

export default component.exports